// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard-dashboardCardBox-vl55c {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  grid-gap: 24px;
}

.Dashboard-bookingCardContainer-xhcCB {
  background: var(--background-primary);
  padding: 24px;
  margin-top: 24px;
  border-radius: var(--radius-3);
}

.Dashboard-bookingCardTitle-g_pYe {
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: var(--primary-foreground);
  margin-bottom: 18px;
  text-align: start;
}

.Dashboard-showMoreLinkContainer-xdJy7 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-top: 18px;
}

@media (max-width: 1130px) and (min-width: 992px) {
  .Dashboard-dashboardCardBox-vl55c {
    grid-template-columns: 100%;
  }
}

@media (max-width: 991px) {
  .Dashboard-dashboardCardBox-vl55c {
    grid-template-columns: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".dashboardCardBox {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  grid-gap: 24px;\n}\n\n.bookingCardContainer {\n  background: var(--background-primary);\n  padding: 24px;\n  margin-top: 24px;\n  border-radius: var(--radius-3);\n}\n\n.bookingCardTitle {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26px;\n  color: var(--primary-foreground);\n  margin-bottom: 18px;\n  text-align: start;\n}\n\n.showMoreLinkContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 18px;\n}\n\n@media (max-width: 1130px) and (min-width: 992px) {\n  .dashboardCardBox {\n    grid-template-columns: 100%;\n  }\n}\n\n@media (max-width: 991px) {\n  .dashboardCardBox {\n    grid-template-columns: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardCardBox": `Dashboard-dashboardCardBox-vl55c`,
	"bookingCardContainer": `Dashboard-bookingCardContainer-xhcCB`,
	"bookingCardTitle": `Dashboard-bookingCardTitle-g_pYe`,
	"showMoreLinkContainer": `Dashboard-showMoreLinkContainer-xdJy7`
};
module.exports = ___CSS_LOADER_EXPORT___;
